import { ListingGroupGridItemData, } from '../interface';

export function fromViewModelToBulkModel(itemData: ListingGroupGridItemData) {
  const condition = itemData.Condition || {};
  if (condition.Attribute === '' && condition.Operand === '') {
    condition.Operand = 'All';
  }
  return {
    Id: itemData.Id,
    AssetGroupId: itemData.AssetGroupId,
    IsExcluded: itemData.IsExcluded,
    IsLeaf: itemData.IsLeaf,
    Condition: itemData.Condition,
    ParentId: itemData.ParentId,
  };
}
